import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import InputBase from '@material-ui/core/InputBase';

import TemplateItem from './TemplateItem';
import { templateMngService } from '../../services';
import { alertActions } from '../../modules/alert';

class TemplateMng extends Component {
    mounted = true;
    constructor(props) {
        super(props);
        this.state = {
            completed: 0,
            searchKeyword: '',
            templateList: []
        };

        this.setStateTemplateList();
    }

    stateRefresh = () => {
        this.setState({
            completed: 0,
            searchKeyword: '',
            templateList: []
        });

        this.setStateTemplateList();
    };

    componentDidMount = () => {
        this.timer = setInterval(this.progress, 20);
    };
    componentWillUnmount = () => {
        this.mounted = false;
    };

    setStateTemplateList = async () => {
        templateMngService.list()
            .then(response => {
                console.log(response.data);
                if (this.mounted) {
                    this.setState({ templateList: response.data });
                }
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    progress = () => {
        const { completed } = this.state;
        this.setState({ completed: completed >= 100 ? 0 : completed + 1 });
    };

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };

    render() {
        const filteredComponents = (templateList, searchKeyword) => {
            templateList = templateList.filter((templateInfo) => {
                return templateInfo.name.indexOf(searchKeyword) > -1;
            });
            return templateList.map((templateInfo, i) => {
                return <TemplateItem key={i} stateRefresh={this.stateRefresh} templateInfo={templateInfo} />;
            });
        };

        // const cellList = ["썸네일", "템플릿명", "관리설정"];
        const cellList = ["템플릿명", "관리설정"];

        return (
            <React.Fragment>
                <h2 className="s-page-tit">
                    템플릿 관리
                </h2>
                <div className="search-wrapper s-normal-box">
                    <InputBase
                        placeholder="템플릿 검색"
                        className="input-box w100per"
                        name="searchKeyword"
                        value={this.state.searchKeyword}
                        onChange={this.handleValueChange}
                    />
                </div>
                <div className="search-result-wrapper contents-mng s-normal-box s-mt-30">
                    <div className="search-result-top">
                        <span>검색결과: {this.state.templateList.length}</span>
                        <span><button className="button w98-button white-button" name="초기화" onClick={this.stateRefresh}><img src="/assets/images/ic-refresh.svg" alt="초기화" className="ic-refresh" />초기화</button></span>
                        <span>
                            <Link to={"/templateAdd"}>
                                <button className="button w98-button white-button" name="신규등록"><img src="/assets/images/ic-register.svg" alt="" className="ic-register" />신규등록</button>
                            </Link>
                        </span>
                    </div>
                    <table className="w100per">
                        <colgroup>
                            {/* <col width="20%"/> */}
                            <col width="80%" />
                            <col width="20%" />
                        </colgroup>
                        <thead className="table-head">
                            <tr>
                                {cellList.map((cell, i) => {
                                    return <th className="table-head-cell" key={i}>{cell}</th>;
                                })}
                            </tr>
                        </thead>
                        <tbody className="table-body">
                            {this.state.templateList &&
                                filteredComponents(this.state.templateList, this.state.searchKeyword)
                            }
                            {(this.state.templateList &&
                                this.state.templateList.length === 0) &&
                                <tr>
                                    <td className="text-align-center" colSpan={3}>
                                        <img src={"/assets/images/ic-no-data.svg"} alt="데이터없음" /><br />
                                        데이터가 없습니다.
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </React.Fragment>
        );
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(TemplateMng);